<template>
  <div class="home-page">
    <div class="home-header">
      <div class="home-header-bg" style="background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));"></div>
      <div class="home-header-bar">
        <button type="button" class="nav-icon-btn" @click="toNotice()"><img src="/img/home/xx.png" alt=""></button>
        <button type="button" class="nav-icon-btn" @click="toMine()"><img src="/img/home/gr.png" alt=""></button>
      </div>
    </div>

    <div class="home-body">
      <div class="notice-wrap">
        <van-notice-bar
          class="notice-bar"
          scrollable
          text="歡迎加入我們！我們將帶給您極致的愉悅體驗。請係好安全帶。性服務每日上午9:00至晚上9:00提供。如果您錯過了服務時間，請於隔天聯絡前台重新預約！約會流程：聯絡前台，選擇您心儀的女孩，完成指定活動，即可獲得一次免費的本地約會。"
          style="color: rgb(102, 102, 102); background: rgb(245, 245, 245);"
        />
      </div>

      <div class="banner-wrap">
        <van-swipe class="banner-swipe" :autoplay="3000" indicator-color="#f560cd">
          <van-swipe-item v-for="(img, idx) in banners" :key="idx">
            <img :src="img" class="banner-img" />
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="recommend-section">
        <div class="section-badge">推薦影片</div>
        <div class="recommend-scroll">
          <div v-for="(item, idx) in recommendList" :key="idx" class="video-card recommend-card" @click="toVideoDetail(item)">
            <div class="video-card-cover square-cover">
              <img :src="item.img" alt="">
              <span class="video-card-title">{{ item.title }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="video-section">
        <div class="section-badge">熱門視頻</div>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="hot-grid">
            <div v-for="(item, idx) in hotList" :key="idx" class="video-card hot-card" @click="toVideoDetail(item)">
              <div class="video-card-cover landscape-cover">
                <img :src="item.img" alt="">
                <div class="video-card-bottom">
                  <span class="video-card-title">{{ item.title }}</span>
                  <span class="video-card-count">播放:{{ item.play_count || 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      banners: [
        "/img/home/e3c0f2807ee1bef9f3bde3e8d6e4a700.jpg",
        "/img/home/157a2363ce7a541be6127f7f2434455b.jpg",
        "/img/home/a7a8d080f6a94191d29d9ac7a4891b69.jpg"
      ],
      recommendList: [],
      hotList: []
    };
  },
  methods: {
    toNotice() {
      if (localStorage.getItem("token")) {
        this.$router.push({ path: "/Notice" });
      } else {
        this.$router.push({ path: "/Login" });
      }
    },
    toMine() {
      if (localStorage.getItem("token")) {
        this.$router.push({ path: "/Mine" });
      } else {
        this.$router.push({ path: "/Login" });
      }
    },
    toVideoDetail(item) {
      if (item && item.id) {
        this.$router.push({ path: "/PlayVideo", query: { id: item.id } });
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.getVideoList();
        this.$toast(this.$t("reservation.refresh"));
      }, 500);
    },
    getVideoList() {
      const fetchPage = (id, page) => {
        return this.$http({
          method: "get",
          data: { id, page },
          url: "video_list"
        }).then(res => {
          if (res && res.code === 200) {
            return res.data && res.data.data ? res.data.data : (Array.isArray(res.data) ? res.data : []);
          }
          return [];
        });
      };

      // 遍历请求后端数据库 video 表数据 (vod_class_id=5)
      let pages = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      let promises = pages.map(p => fetchPage(5, p));

      Promise.all(promises).then(results => {
        let allVideos = [];
        results.forEach(list => {
          if (list && list.length > 0) {
            allVideos = allVideos.concat(list);
          }
        });

        // 去重处理
        let uniqueMap = new Map();
        allVideos.forEach(item => {
          if (item && item.id && !uniqueMap.has(item.id)) {
            uniqueMap.set(item.id, item);
          }
        });
        let uniqueList = Array.from(uniqueMap.values());

        // vod_hot == 1 为推荐，vod_hot == 0 为热门
        let recs = uniqueList.filter(v => v.vod_hot == 1);
        let hots = uniqueList.filter(v => v.vod_hot == 0);

        // 确保热门视频为偶数数量
        if (hots.length % 2 !== 0) {
          hots = hots.slice(0, hots.length - 1);
        }

        this.recommendList = recs.map(v => ({
          id: v.id,
          title: v.vod_name || v.title || v.name,
          img: v.vod_pic || v.cover || v.img,
          play_count: v.vod_score_num || v.count || 0,
          vod_hot: v.vod_hot
        }));

        this.hotList = hots.map(v => ({
          id: v.id,
          title: v.vod_name || v.title || v.name,
          img: v.vod_pic || v.cover || v.img,
          play_count: v.vod_score_num || v.count || 0,
          vod_hot: v.vod_hot
        }));
      });
    }
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getVideoList();
    }
  }
};
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  padding-bottom: 4.33333rem;
  background: #fff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.home-header {
  position: relative;
  width: 100%;
  height: 12.8vw;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top, 0);
  box-sizing: content-box;
  overflow: hidden;
  flex-shrink: 0;
}

.home-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-repeat: no-repeat;
  background-position: top;
  background-size: 100% auto;
}

.home-header-bar {
  position: relative;
  z-index: 2;
  height: 12.8vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4.267vw;
}

.nav-icon-btn {
  width: 6.4vw;
  height: 6.4vw;
  padding: 0;
  border: none;
  background: transparent;
  flex-shrink: 0;
  cursor: pointer;
}

.nav-icon-btn img {
  width: 100%;
  height: 100%;
  display: block;
  -o-object-fit: contain;
  object-fit: contain;
}

.home-body {
  position: relative;
  z-index: 1;
  margin-top: -1.6vw;
  background: #fff;
  border-radius: 2.133vw 2.133vw 0 0;
}

.notice-wrap {
  padding: 1.6vw 3.2vw 1.067vw;
}

.notice-bar {
  border-radius: 133.2vw !important;
  font-size: 3.2vw !important;
  height: 8.533vw !important;
  line-height: 8.533vw !important;
}

::v-deep .notice-bar .van-notice-bar__wrap {
  display: flex;
  align-items: center;
}

::v-deep .notice-bar .van-notice-bar__content {
  font-size: 3.2vw;
  line-height: 8.533vw;
}

.banner-wrap {
  padding: 0 3.2vw 1.6vw;
}

.banner-swipe {
  height: 42.667vw;
  border-radius: 2.133vw;
  overflow: hidden;
}

.banner-img {
  display: block;
  width: 100%;
  height: 42.667vw;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 2.133vw;
}

.section-badge {
  display: inline-block;
  margin: 2.133vw 3.2vw 1.6vw;
  padding: 1.333vw 3.733vw;
  font-size: 3.733vw;
  font-weight: 600;
  color: #fff;
  background: #3d4266;
  border-radius: 1.067vw;
  line-height: 1.2;
}

.recommend-section {
  margin-bottom: 1.067vw;
}

.recommend-scroll {
  display: grid;
  grid-template-rows: repeat(2, auto);
  grid-auto-flow: column;
  grid-auto-columns: 33.67889vw;
  gap: 1.333vw;
  padding: 0 3.2vw 2.667vw;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.recommend-scroll::-webkit-scrollbar {
  display: none;
}

.recommend-card {
  width: 100%;
}

.hot-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.6vw;
  padding: 0 3.2vw 2.667vw;
}

.hot-grid .hot-card {
  width: calc(50% - 0.8vw);
}

.video-card {
  cursor: pointer;
  border-radius: 1.067vw;
  overflow: hidden;
}

.video-card-cover {
  position: relative;
  width: 100%;
  background: #f0f0f0;
}

.video-card-cover img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  display: block;
}

.square-cover {
  height: 0;
  padding-bottom: 100%;
}

.square-cover img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.landscape-cover {
  height: 0;
  padding-bottom: 65%;
}

.landscape-cover img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.video-card-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 3.467vw;
  color: #fff;
  line-height: 1.4;
}

.square-cover .video-card-title {
  padding: 0.267vw 0.267vw;
  min-height: 6.4vw;
}

.square-cover .video-card-title,
.video-card-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.55);
}

.video-card-bottom {
  justify-content: space-between;
  gap: 1.067vw;
  min-height: 6.933vw;
  padding: 1.6vw 1.333vw;
}

.video-card-bottom .video-card-title {
  flex: 1;
  min-width: 0;
  font-size: 3.467vw;
}

.video-card-count {
  flex-shrink: 0;
  font-size: 3.2vw;
  color: #fff;
  white-space: nowrap;
}

.video-section {
  padding: 0 0 3.2vw;
}
</style>